<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :disabled="disabled"
    min-width="290px"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="text"
        @input="onTextInput"
        :label="label"
        placeholder="HH:mm"
        prepend-icon="mdi-clock-outline"
        outlined
        dense
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
      ></v-text-field>
    </template>
    <v-time-picker
      :value="value"
      format="24hr"
      scrollable
      @input="onPicked"
    ></v-time-picker>
  </v-menu>
</template>

<script>
import { maskTimeInput } from "@/utils/scheduling";

const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/;

export default {
  name: "ScheduledTimeField",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Hora",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: false,
      text: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(next) {
        this.text = next;
      },
    },
  },
  methods: {
    onTextInput(raw) {
      this.text = maskTimeInput(raw);
      if (TIME_RE.test(this.text)) {
        this.$emit("input", this.text);
      }
    },
    onPicked(time) {
      this.text = time;
      if (TIME_RE.test(time)) {
        this.$emit("input", time);
        this.menu = false;
      }
    },
  },
};
</script>